import Vue from "vue";
import { noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.CORE_API_URL + "/especialidade";

class SpecialtyService {
  findAll() {
    return Vue.prototype.$axios.get(apiUrl, {
      headers: noTenant()
    });
  }
}

export default new SpecialtyService();
